import React from "react";

import "./section-description.css";

export const SectionDescription = ({description}) => (
    <div className="s-description" dangerouslySetInnerHTML={{ __html: description }}/>
)
